module.exports = new __parcel__URL__("battlepass_unlocked.14e809d6.png").toString();